module.exports = __webpack_public_path__ + "img/symbol_6.c4d71d55.png";